import * as React from "react";
interface Props {
  gridColumn: string;
  lock: React.MutableRefObject<string>;
  edge: "left" | "right";
  iframeRef: React.RefObject<HTMLIFrameElement>;
}
function Handle(props: Props) {
  const {
    gridColumn,
    lock,
    edge,
    iframeRef
  } = props;
  return <div className={"d1mmz2b6"} onMouseDown={() => {
    lock.current = edge;
    if (iframeRef.current) {
      iframeRef.current.style.userSelect = "none";
      iframeRef.current.style.pointerEvents = "none";
    }
  }} style={{
    gridColumn
  }}>
      <svg width="56" height="56" viewBox="0 0 56 56">
        <path fill="currentColor" d="M27 18h2v20h-2V18zm-6 0h2v20h-2V18zm12 0h2v20h-2V18z" />
      </svg>
    </div>;
}
export default React.memo(Handle);

require("./Handle.linaria.module.css!=!../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Handle.tsx");